import React from 'react'

import s from './styles.module.scss'

import { Spinner } from '../../../components/atoms'
import { cn } from '../../../shadcn/utils'

export const Loader = ({
  size = 72,
  color = 'gradient',
  className,
  style,
}: {
  size?: number
  color?: 'black' | 'white' | 'gradient' | 'grey'
  className?: string
  style?: React.CSSProperties
}) => {
  return (
    <div className={cn(s.root, className)} style={style}>
      <Spinner color={color} width={size} height={size} />
    </div>
  )
}
